export const regions = {
    "Deutschland": [
        "Bayern",
        "Baden-Württemberg",
        "Berlin",
        "Brandenburg",
        "Bremen",
        "Hamburg",
        "Hessen",
        "Mecklenburg-Vorpommern",
        "Niedersachsen",
        "Nordrhein-Westfalen",
        "Rheinland-Pfalz",
        "Saarland",
        "Sachsen",
        "Sachsen-Anhalt",
        "Schleswig-Holstein",
        "Thüringen"
    ],
    "Österreich": [
        "Burgenland",
        "Kärnten",
        "Niederösterreich",
        "Oberösterreich",
        "Salzburg",
        "Steiermark",
        "Tirol",
        "Vorarlberg",
        "Wien"
    ],
    "Schweiz": [
        "Aargau",
        "Appenzell Ausserrhoden",
        "Appenzell Innerrhoden",
        "Basel-Landschaft",
        "Basel-Stadt",
        "Bern",
        "Freiburg",
        "Genf",
        "Glarus",
        "Graubünden",
        "Jura",
        "Luzern",
        "Neuenburg",
        "Nidwalden",
        "Obwalden",
        "Schaffhausen",
        "Schwyz",
        "Solothurn",
        "St. Gallen",
        "Thurgau",
        "Tessin",
        "Uri",
        "Waadt",
        "Wallis",
        "Zug",
        "Zürich"
    ]
};
